"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ChartTypeSelect;

var _lodash = require("lodash");

var _react = _interopRequireWildcard(require("react"));

var _editor = require("../../../components/visualizations/editor");

var _visualizationsSettings = require("../../visualizationsSettings");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ChartTypeSelect(props) {
  var chartTypes = (0, _react.useMemo)(() => {
    var result = [{
      type: "line",
      name: "Line",
      icon: "line-chart"
    }, {
      type: "column",
      name: "Bar",
      icon: "bar-chart"
    }, {
      type: "area",
      name: "Area",
      icon: "area-chart"
    }, {
      type: "pie",
      name: "Pie",
      icon: "pie-chart"
    }, {
      type: "scatter",
      name: "Scatter",
      icon: "circle-o"
    }, {
      type: "bubble",
      name: "Bubble",
      icon: "circle-o"
    }, {
      type: "heatmap",
      name: "Heatmap",
      icon: "th"
    }, {
      type: "box",
      name: "Box",
      icon: "square-o"
    }];

    if (_visualizationsSettings.visualizationsSettings.allowCustomJSVisualizations) {
      result.push({
        type: "custom",
        name: "Custom",
        icon: "code"
      });
    }

    return result;
  }, []);
  return /*#__PURE__*/_react.default.createElement(_editor.Select, props, (0, _lodash.map)(chartTypes, (_ref) => {
    var type = _ref.type,
        name = _ref.name,
        icon = _ref.icon;
    return /*#__PURE__*/_react.default.createElement(_editor.Select.Option, {
      key: type,
      value: type,
      "data-test": "Chart.ChartType.".concat(type)
    }, /*#__PURE__*/_react.default.createElement("i", {
      className: "fa fa-".concat(icon),
      style: {
        marginRight: 5
      }
    }), name);
  }));
}
//# sourceMappingURL=ChartTypeSelect.js.map